import { getAdvertId } from "./bookmarks"

const apiBaseUrl = SiteInfo.yiiLadiesApiUrl
const apiEndpoint = `${apiBaseUrl}/v1/bookmarks/tags/list`
const userTagListApiEndpoint = (userId: number) => `/api/bookmarks/${userId}/tags/list`

export interface TagListApiItem {
    TagID: string
    Tag: string
}

export interface TagListApiResponse {
    tags: Array<TagListApiItem>
    advertTags: Array<number>
    error: boolean
    code: number
    errorMessage: string
}

export interface TagListUserApiItem {
    tagId: string
    userId: string
    tagSlug: string
    tagName: string
    advertIds: Array<number>
    canonicalIds: Array<string>
}

export interface TagListUserApiResponse {
    entries: Array<TagListUserApiItem>
    error: boolean
    code: number
    errorMessage: string
}

// Singleton; only ever fetch once and distribute the same list to all callers
let bookmarkTagList: Promise<TagListApiResponse> | null = null

export function getTagList(): Promise<TagListApiResponse> {
    if (!bookmarkTagList) {
        bookmarkTagList = fetchTags().catch((error) => {
            bookmarkTagList = null

            // Propagate error to caller in case they want to handle it as well,
            // e.g. to retry getting the list
            throw error
        })
    }

    return bookmarkTagList
}

async function fetchTags(): Promise<TagListApiResponse> {
    const params = new URLSearchParams({
        advertId: getAdvertId() || "0",
    })

    const response = await fetch(`${apiEndpoint}?${params.toString()}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
    })

    if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`)
    }

    return response.json()
}

// Singleton; only ever fetch once and distribute the same list to all callers
let advertTagList: Promise<TagListUserApiResponse> | null = null

export function getUserTagListWithConnectedAdverts(): Promise<TagListUserApiResponse> {
    if (!advertTagList) {
        advertTagList = fetchAdvertTags().catch((error) => {
            advertTagList = null

            // Propagate error to caller in case they want to handle it as well,
            // e.g. to retry getting the list
            throw error
        })
    }

    return advertTagList
}

async function fetchAdvertTags(): Promise<TagListUserApiResponse> {
    const userId = userData.userId || 0
    const apiUrl = `${userTagListApiEndpoint(userId)}`

    const response = await fetch(apiUrl, {
        method: "GET",
        mode: "cors",
        credentials: "include",
    })

    if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`)
    }

    return response.json()
}
